export var USE_RETRIEVE_TEAM_FEED = "useRetrieveTeamFeed";
export var USE_RETRIEVE_PLAYER_FEED = "useRetrievePlayerFeed";
